// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageTitle_wrapper__YDKbV"};